<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-data-table
      :headers="headers"
      :items="list"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <template>
          <v-btn
            class="float-right mt-3 mr-3"
            color="primary"
            dark
            @click="addMicro"
            >New micro</v-btn
          >
        </template>
        <v-toolbar flat color="white">
          <v-toolbar-title>Microes</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <v-row class="ml-2 mr-2">
          <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
            <v-text-field
              v-model="filter_name"
              label="Micro Name"
              outlined
              dense
              @keyup="searchFilter"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.microid`]="{ item }">
        {{ list .map(function (x) { return x.microid; }) .indexOf(item.microid) + 1 }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <p v-if="item.status == false">
          <span title="Not Active"
            ><i class="status fa fa-times-circle red--text"></i
          ></span>
        </p>
        <p v-if="item.status == true">
          <span title="Active"
            ><i class="status fa fa-check-circle green--text"></i
          ></span>
        </p>
      </template>
      <template  v-slot:[`item.action`]="{ item }">
        <v-icon
          title="Edit"
          small
          class="mr-2"
          color="#1976D2"
          @click.stop="editItemMethod(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          title="Delete"
          small
          @click.stop="deleteItemMethod(item)"
          color="#FF5252"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <DeleteMicro
      :deleteMicro="deleteMicro"
      :deleteItem="deleteItem"
      v-on:DialogClose="DialogClose($event)"
    />

  </v-container>
</template>

<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import DeleteMicro from "@/components/Micros/DeleteMicro";
export default {
  data() {
    return {
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Microes",
          disabled: true,
        },
      ],

      headers: [
        { text: "#", value: "microid" },
        { text: "Micro Name", value: "microname" },
        { text: "Status", value: "status" },
        { text: "Action ", value: "action" },
      ],

      filter_name  : "" ,
      list : [],
      deleteMicro: false,
      deleteItem: {},

    };
  },
  components: {
    Breadcrumbs,
    DeleteMicro
  },

  created() {
    this.getMicroes();
  },
  methods: {
    getMicroes(){
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/micro"
        )
        .then((response) => {
          this.PagesNumber = response["data"]["meta"]["last_page"];
          this.list = response["data"]["data"];
        });
    },
    searchFilter (){
      console.log('HI')
    },
    addMicro (){
      this.$router.push({ name: "AddMicro" }).catch(() => {});
    },
    editItemMethod (item) {
      console.log(item)
      this.$router.push({ name: "EditMicro" , params: { id: item.microid }  }).catch(() => {});
    },
    deleteItemMethod(item){
      this.deleteMicro = true
      this.deleteItem = item
    },
    DialogClose(val) {
      if (val == true) {
        this.getMicroes();
      }
      this.deleteMicro = false;
    },
  },
};
</script>